import { useCallback } from "react";
import swan from "../services/swanservice";


export const useMeasurementSocket = () => {
    const handleWebsocket=useCallback(({scanId,onClose,onError,onSuccess})=>{
        swan.measurement.handleMeasurementSocket({
			scanId: scanId,
			onOpen: () => {
				console.log("open");
				
				// handleWebSocketCapture(`${shopDomain}/webSocket`, scanUniqueKey, "open", "measurement_recommendation", email);
				// getProductVariants();
			},
			onClose: () =>{
				console.log("close");
				
                onClose?.()
                //  handleWebSocketCapture(`${shopDomain}/webSocket`, scanUniqueKey, "close", "measurement_recommendation", email)},
            },
			onError: (err) => {
				onError?.(err);
				// handleWebSocketCapture(`${shopDomain}/webSocket`, scanUniqueKey, "error", "measurement_recommendation", email);
			},  
			onSuccess:onSuccess,
		});
    },[])

    return handleWebsocket;
};
